import React, { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoginPage from './LoginPage';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, hasAccess, accessDenied, login } = useAuth();

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage onLogin={login} />;
  }

  if (accessDenied) {
    return (
      <div className="access-denied-container">
        <div className="access-denied-box">
          <h1>Access Denied</h1>
          <p>
            You do not have permission to access the Provider Validator application.
          </p>
          <p>
            Please contact your administrator to request the <strong>ProviderValidator.ReadWrite</strong> role.
          </p>
        </div>
      </div>
    );
  }

  if (!hasAccess) {
    return (
      <div className="access-denied-container">
        <div className="access-denied-box">
          <h1>Access Denied</h1>
          <p>
            You do not have the required role to access this application.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
